var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3702 4.86993L6.40394 13.8377C5.9233 14.3182 5.32109 14.6591 4.66169 14.8239L1.22519 15.6834C1.0995 15.7149 0.967805 15.7133 0.842928 15.6787C0.718052 15.6442 0.604259 15.5779 0.512639 15.4862C0.421019 15.3946 0.354697 15.2808 0.320138 15.1559C0.285579 15.0311 0.283961 14.8994 0.315442 14.7737L1.17494 11.3372C1.33973 10.6778 1.68063 10.0756 2.16119 9.59493L11.1274 0.62793L15.3702 4.87068V4.86993Z",
    fill: "#3377EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.9c3ed31f82d3a7cc45e7e61f1133d1de.svg";
export { ForwardRef as ReactComponent };